import {
  Check,
  CheckCircle,
  CheckCircle2,
  Eye,
  FileCheck,
  Mail,
  PlusCircleIcon,
  Search,
  X,
} from "lucide-react";
import React, { useEffect, useState } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  getEmailTemplateList,
  getSentEmailList,
  searchUsers,
  sendEmail,
} from "../../services/EmailService.js/emailService";
import EmailVariablesBuilder from "../../components/BulkEmail/VariableBuilder";
import VariablesInstructionCard from "../../components/BulkEmail/VariablesInstruction";
import { useEmailStore } from "../../store/emailStore";
import VariableInstructions2 from "../../components/BulkEmail/VariableInstructions2";
import { GetUserDataByIdService } from "../../services/apiService";

const SendEmail = () => {
  const { showInstruction, setShowInstruction } = useEmailStore();

  const Font = Quill.import("formats/font");
  Font.whitelist = [
    "arial",
    "roboto",
    "open-sans",
    "poppins",
    "montserrat",
    "lato",
    "times-new-roman",
    "georgia",
    "merriweather",
    "playfair",
    "courier-new",
    "fira-code",
    "oswald",
    "bebas",
    "pacifico",
  ];
  Quill.register(Font, true);

  /* ================= TOOLBAR ================= */
  const modules = {
    toolbar: [
      [{ font: Font.whitelist }],
      [{ size: ["small", false, "large", "huge"] }],
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ align: [] }],
      ["link", "image", "code-block"],
      ["clean"],
    ],
  };
  const [search, setSearch] = useState("");
  const [preview, setPreview] = useState(null);
  const [showPreview, setShowPreview] = useState(null);
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState(null);
  const [subject, setSubject] = useState(null);
  const [schedule, setSchedule] = useState(null);
  const [priority, setPriority] = useState("normal");
  const [status, setStatus] = useState(null);
  const [templateList, setTemplatelist] = useState(null);
  const [emailList, setEmailList] = useState(null);
  const [templateId, setTemplateId] = useState(null);
  const [userData, setUserData] = useState(null);
  const [searchField, setSearchField] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [searchResponse, setSearchResponse] = useState(null);
  const [recipients, setRecipients] = useState([{ email: "", user_id: "" }]);
  const [customVariables, setCustomVariables] = useState(null);

  const [sendEmailResponse, setSendEmailResponse] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const [mode, setMode] = useState("all_users"); // "all" | "individual"
  const [userId, setUserId] = useState("");
  const [email, setEmail] = useState("");

  const handleRecipients = (email, userId) => {
    if (recipients.some((val) => val.email === email)) {
      return setRecipients(recipients.filter((val) => val.email !== email));
    }
    setRecipients([...recipients, { email, user_id: userId }]);
  };

  const handleFile = (e) => {
    const selectedFile = e.target.files?.[0];
    if (!selectedFile) return;

    setFile(selectedFile);

    const url = URL.createObjectURL(selectedFile);
    setPreview(url);
  };

  const getSentEmailReport = async () => {
    try {
      const res = await getSentEmailList();
      if (res?.data) {
        setEmailList(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    return () => {
      if (preview) {
        URL.revokeObjectURL(preview);
      }
    };
  }, [preview]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchField);
    }, 500); // 500ms delay

    return () => clearTimeout(timer);
  }, [searchField]);

  useEffect(() => {
    const handleSearch = async () => {
      if (!debouncedSearch) return;

      const res = await searchUsers({ search: debouncedSearch });
      if (res) {
        setEmail(res?.user?.email_address);
        setSearchResponse(res);
      }
    };

    handleSearch();
  }, [debouncedSearch]);

  useEffect(() => {
    console.log(
      "custom variables",
      "++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++",
    );

    console.log(customVariables);

    console.log(
      "custom variables",
      "++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++",
    );
  }, [customVariables]);

  useEffect(() => {
    getSentEmailReport();
  }, []);

  const statusStyles = {
    Sent: "bg-green-100 text-green-700",
    Scheduled: "bg-blue-100 text-blue-700",
    Draft: "bg-yellow-100 text-yellow-700",
  };

  const getTemplateList = async () => {
    try {
      const res = await getEmailTemplateList();
      if (res) {
        setTemplatelist(res.data);
      }
    } catch (error) {}
  };

  const setStatesFromTemplate = (id, subject, bodyHtml) => {
    console.log(
      "state setter function arguments++++++++++++++++++++++++",
      id,
      subject,
      bodyHtml,
    );

    setTemplateId(id);
    setMessage(bodyHtml);
    setSubject(subject);
  };

  const handleSendEmail = async () => {
    // const recipients = [{ email, user_id: userId.slice(4, 9) }];

    const filteredRecipients = recipients?.slice(1).map((item) => {
      return { email: item.email, user_id: item.user_id?.slice(4, 9) };
    });
    if (status !== "scheduled") {
      setSchedule("");
    }

    try {
      const payload = {
        template_id: templateId,
        subject,
        body_html: message,
        send_to_type: mode,
        recipients: filteredRecipients,
        scheduled_at: schedule,
        priority,
        variables: customVariables,
      };

      if (status) {
        payload.status = status;
      }

      const res = await sendEmail(payload);

      if (res) {
        setSendEmailResponse(res);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getTemplateList();
  }, []);

  return (
    <div className="min-h-screen mt-2 bg-slate-100 p-4 md:p-8">
      <style>
        {`
  .compact-quill .ql-container {
    min-height: 160px;
  }
  .compact-quill .ql-editor {
    min-height: 120px;
    max-height: 280px;
    overflow-y: auto;
  }
`}
      </style>

      <div className="mx-auto max-w-7xl space-y-2">
        {/* Send Email */}
        <div className="bg-gradient-to-r from-blue-900 via-blue-700 to-blue-600 rounded-lg px-6 py-5 text-white">
          <h1 className="text-2xl font-semibold">Send Email</h1>
          <p className="text-sm opacity-90">You can send your emails here</p>
        </div>

        {/* show success message */}
        {(sendEmailResponse?.status?.code === 200 ||
          sendEmailResponse?.data?.status?.code === 200) && (
          <div className="w-full flex justify-center mt-6">
            <div
              className="flex items-start gap-3 w-full md:w-[70%] xl:w-[50%] 
                    bg-green-50 border border-green-200 
                    text-green-800 
                    px-5 py-4 rounded-xl shadow-sm 
                    animate-fade-in"
            >
              {/* Icon */}
              <div className="mt-1">
                <CheckCircle className="w-10 h-10 text-green-600 animate-bounce" />
              </div>

              {/* Message Content */}
              <div className="flex flex-col">
                <span className="font-semibold text-base">Request Saved</span>
                <span className="text-sm text-green-700 mt-1">
                  {sendEmailResponse?.message ||
                    sendEmailResponse?.status?.message}
                </span>
              </div>
            </div>
          </div>
        )}

        <div className="rounded-xl bg-white px-2 shadow-sm">
          <div className="grid grid-cols-1  md:grid-cols-2 p-2 gap-6">
            {/* Send To */}
            <div className="w-full max-w-3xl mx-auto ">
              <h2 className="text-xl mb-2 font-semibold text-gray-800">
                Select Recipient
              </h2>

              {/* Toggle Tabs */}
              <div className="relative flex bg-gray-100 rounded-xl p-1">
                <div
                  className={`absolute top-1 bottom-1 w-1/2 rounded-lg bg-white shadow transition-all duration-300 ${
                    mode === "all_users" ? "left-1" : "left-1/2"
                  }`}
                />

                <button
                  onClick={() => {
                    setMode("all_users");
                    setUserId("");
                    setEmail("");
                  }}
                  className={`relative z-10 w-1/2 py-2 text-sm font-medium transition ${
                    mode === "all_users"
                      ? "text-blue-600"
                      : "text-gray-500 hover:text-gray-700"
                  }`}
                >
                  All Users
                </button>

                <button
                  onClick={() => setMode("individual")}
                  className={`relative z-10 w-1/2 py-2 text-sm font-medium transition ${
                    mode === "individual"
                      ? "text-blue-600"
                      : "text-gray-500 hover:text-gray-700"
                  }`}
                >
                  Individual
                </button>
              </div>

              {/* selected recipients */}
              {/* <div>adarshjha@gmail.com</div> */}

              {/* {searchResponse && (
                <div>{searchResponse?.data?.email || "Nothing Found"}</div>
              )} */}

              {/* individual User Section */}
              {mode === "individual" && (
                <div className="space-y-4">
                  {/* User ID Input */}
                  <div>
                    <label className="block text-sm font-medium text-gray-600 mb-1">
                      Search
                    </label>
                    <div className="flex flex-col gap-2">
                      <input
                        autoFocus
                        type="search"
                        value={searchField}
                        onChange={(e) => setSearchField(e.target.value)}
                        placeholder="UserId | Name | Mobile | Email"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                      />
                      {searchResponse && (
                        <div className="mt-2  max-h-[200px] overflow-y-auto">
                          {searchResponse?.data?.data?.map((item, index) => (
                            <button
                              type="button"
                              onClick={() =>
                                handleRecipients(
                                  item.email_address,
                                  item.user_id,
                                )
                              }
                              key={index}
                              className={` flex items-center text-black justify-between gap-2 ${recipients.some((val) => val.email === item.email_address) ? "bg-green-50 text-green-700 border border-green-400" : "bg-blue-50 text-blue-700 border border-blue-400"}  text-sm mb-2 py-1 px-3 rounded-full`}
                            >
                              {item.email_address}
                              <div className="">
                                {recipients.some(
                                  (val) => val.email === item.email_address,
                                ) ? (
                                  <CheckCircle />
                                ) : (
                                  <PlusCircleIcon />
                                )}
                              </div>
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Email Readonly Field */}
                  {email && (
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1">
                        User Email
                      </label>
                      <input
                        type="email"
                        value={email}
                        readOnly
                        className="w-full px-4 py-2 bg-gray-100 border border-gray-300 rounded-lg text-gray-700 cursor-not-allowed"
                      />
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="w-full grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6">
              {/* Status */}
              <div className="flex flex-col justify-end">
                <label className="mb-1 text-sm font-medium text-slate-600">
                  Status
                </label>
                <select
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                  className="h-10 w-full rounded-lg border border-slate-300 bg-white px-3 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                >
                  <option value="">Select Status</option>
                  <option value="scheduled">Schedule</option>
                  <option value="draft">Draft</option>
                </select>
              </div>

              {/* Schedule (only when scheduled) */}
              {status === "scheduled" && (
                <div className="flex flex-col justify-end">
                  <label className="mb-1 text-sm font-medium text-slate-600">
                    Schedule
                  </label>
                  <input
                    type="datetime-local"
                    value={schedule}
                    onChange={(e) => setSchedule(e.target.value)}
                    className="h-10 w-full rounded-lg border border-slate-300 px-3 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                  />
                </div>
              )}

              {/* Priority */}
              <div className="flex flex-col justify-end">
                <label className="mb-1 text-sm font-medium text-slate-600">
                  Priority
                </label>
                <select
                  value={priority}
                  onChange={(e) => setPriority(e.target.value)}
                  className="h-10 w-full rounded-lg border border-slate-300 bg-white px-3 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                >
                  <option value="normal">Normal</option>
                  <option value="high">High</option>
                  <option value="urgent">Urgent</option>
                </select>
              </div>

              {/* Email Template */}
              <div className="flex flex-col justify-end">
                <label className="mb-1 text-sm font-medium text-slate-600">
                  Email Template
                </label>
                <select
                  className="h-10 w-full rounded-lg border border-slate-300 bg-white px-3 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    const selectedTemplate = templateList?.find(
                      (item) => item.id.toString() === selectedId,
                    );

                    if (selectedTemplate) {
                      setStatesFromTemplate(
                        selectedTemplate.id,
                        selectedTemplate.subject,
                        selectedTemplate.body_html,
                      );
                    }
                  }}
                >
                  <option value="">Select Template</option>

                  {templateList?.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* selected recipients */}

          {recipients.length > 1 && (
            <div className=" bg-white">
              <p className=" text-2xl py-2  font-bold text-green-700 flex justify-center gap-2 items-center">
                {" "}
                <div>{recipients.length - 1}</div>
                Selected Recipients
              </p>
              <div className="max-h-[250px] flex flex-col items-start overflow-y-auto shadow-md px-4 py-2 rounded-2xl">
                <div className="flex gap-2 items-center">
                  {recipients
                    ?.slice(1)
                    ?.reverse()
                    ?.map((item) => (
                      <div
                        key={item.user_id}
                        className="bg-green-50 border border-green-400  w-fit mt-4 flex items-center justify-between gap-2 text-green-700 text-sm mb-2 py-1 px-3 rounded-full"
                      >
                        {item.email !== "" && (
                          <div className="flex items-center gap-3">
                            {item.email}
                            <button type="button" className="flex items-center">
                              <Check size={20} />
                            </button>
                          </div>
                        )}
                      </div>
                    ))}
                </div>
              </div>
            </div>
          )}

          <div className="">
            <label className="mb-1 block text-sm font-medium text-slate-600">
              Subject
            </label>
            <input
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              type="text"
              placeholder="Email subject"
              className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
            />
          </div>

          {/* MESSAGE */}
          <div className="my-6 ">
            <label className="text-xs font-semibold text-gray-600 mb-1 block">
              Message
            </label>
            <ReactQuill
              value={message}
              onChange={setMessage}
              modules={modules}
              style={{ height: "280px", padding: "10px", borderRadius: "10px" }}
              theme="snow"
              className="compact-quill"
              placeholder="Write your email template here..."
            />
          </div>

          <div
            className={`grid grid-cols-1 ${showInstruction && "lg:grid-cols-2"}  gap-4 mt-10`}
          >
            {" "}
            <EmailVariablesBuilder setCustomVariables={setCustomVariables} />
            {showInstruction && <VariablesInstructionCard />}
          </div>

          <div className="flex items-center justify-center ">
          

            <div className=" flex gap-3 justify-center  items-center">
              {/* <button className="rounded-lg border border-slate-300 px-10 py-4 text-sm font-medium text-slate-700 hover:bg-slate-100">
              Save Draft
            </button> */}
              <button
                type="button"
                onClick={handleSendEmail}
                className="rounded-lg bg-blue-600 px-10 py-4 text-sm font-medium text-white hover:bg-blue-700 flex items-center gap-2 justify-center"
              >
                <Mail />
                Send Email
              </button>
            </div>
          </div>

          {/* show success message */}
          {(sendEmailResponse?.status?.code === 200 ||
            sendEmailResponse?.data?.status?.code === 200) && (
            <div className="w-full flex justify-center mt-6">
              <div
                className="flex items-start gap-3 w-full md:w-[70%] xl:w-[50%] 
                    bg-green-50 border border-green-200 
                    text-green-800 
                    px-5 py-4 rounded-xl shadow-sm 
                    animate-fade-in"
              >
                {/* Icon */}
                <div className="mt-1">
                  <CheckCircle className="w-10 h-10 text-green-600 animate-bounce" />
                </div>

                {/* Message Content */}
                <div className="flex flex-col">
                  <span className="font-semibold text-base">Request Saved</span>
                  <span className="text-sm text-green-700 mt-1">
                    {sendEmailResponse?.message ||
                      sendEmailResponse?.status?.message}
                  </span>
                </div>
              </div>
            </div>
          )}

          <VariableInstructions2 />
        </div>

        {/* preview */}

        {/* Email Report */}
        <div className="rounded-xl bg-white p-6 shadow-sm ">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <h2 className="text-lg font-semibold text-slate-800">
              Email Report
            </h2>

            <input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search by subject or email"
              className="w-full max-w-sm rounded-lg border border-slate-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
            />
          </div>

          <div className="mt-6 max-h-[300px] overflow-auto rounded-t-2xl">
            <table className="w-full min-w-[900px] border-collapse text-sm ">
              <thead className="bg-gradient-to-r  from-blue-700 to-blue-900 text-left text-white">
                <tr>
                  {[
                    "SRN",
                    "Send To Type",
                    "Subject",
                    "Priority",
                    "Status",
                    "Scheduled On",
                    "Templ. Id",
                  ].map((head) => (
                    <th key={head} className="px-4 py-3 font-medium">
                      {head}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {emailList?.map((row) => (
                  <tr key={row.id} className="border-t hover:bg-slate-50">
                    <td className="px-4 py-3">{row.id}</td>
                    <td className="px-4 py-3">{row.send_to_type}</td>
                    <td className="px-4 py-3">{row.subject}</td>
                    <td className="px-4 py-3">{row.priority}</td>
                    <td className="px-4 py-3">
                      <span
                        className={`rounded-full px-3 py-1 text-xs font-medium ${statusStyles[row.status]}`}
                      >
                        {row.status}
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      {new Date(row.scheduled_at).toLocaleString()}
                    </td>
                    <td className="px-4 py-3">{row.email_template_id}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="mt-4 flex items-center justify-end gap-4 text-sm text-slate-600">
            <button disabled className="cursor-not-allowed opacity-50">
              Prev
            </button>
            <span>Page 1 of 1</span>
            <button disabled className="cursor-not-allowed opacity-50">
              Next
            </button>
          </div>
        </div>
      </div>

      {showPreview && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          {/* Backdrop */}
          <div
            onClick={() => setShowPreview(false)}
            className="absolute inset-0 bg-black/60"
          />

          {/* Preview Container */}
          {preview && file && (
            <div className="relative z-50 w-full max-w-4xl h-[90vh] px-4 flex items-center justify-center">
              {/* PDF Preview */}
              {file.type === "application/pdf" && (
                <div className="relative w-full">
                  <iframe
                    src={preview}
                    title="PDF Preview"
                    className="w-full h-full rounded-xl border bg-white"
                  />

                  <button
                    onClick={() => setShowPreview(false)}
                    className="absolute top-3 right-6 z-50 text-white bg-black/60 rounded-full p-2 hover:bg-black"
                  >
                    <X />
                  </button>
                </div>
              )}

              {/* Image Preview */}
              {file.type.startsWith("image/") && (
                <div className="relative">
                  <img
                    src={preview}
                    alt="File Preview"
                    className="max-h-full max-w-full rounded-xl object-contain bg-black"
                  />

                  <button
                    onClick={() => setShowPreview(false)}
                    className="absolute top-3 right-6 z-50 text-white bg-black/60 rounded-full p-2 hover:bg-black"
                  >
                    <X />
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SendEmail;
